import Vue from "vue";
import BootstrapVue from "bootstrap-vue";

import App from "./App.vue";
import "./assets/scss/app.scss";
import InlineSvgPlugin from 'vue-inline-svg';

Vue.config.productionTip = false;

// Switch to true before deploying!
let productionMode = true;

// Declaring API BASE_URL globally.
// See https://stackoverflow.com/questions/37367588/what-is-the-best-way-to-declare-global-variable-in-vue-js

Vue.prototype.$apiBaseUrl = productionMode
  ? "https://itemizr.gravurapp.com"
  : "http://jti-itemizr-drupal.test:8888";

Vue.use(BootstrapVue);
Vue.use(InlineSvgPlugin);

new Vue({
  render: (h) => h(App),
}).$mount("#app");
